import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useRiderSales } from "@/hooks/use-rider-sales";
import { formatCurrency } from "@/lib/utils";

import { RiderSaleDetailDialog } from "./rider-sale-detail-dialog";

import type { RiderSale } from "@artisancode/api-types";

export function RiderPendingPaymentDetailDialog({
  riderId,
  riderName,
  onOpenChange,
}: {
  riderId: string | null;
  riderName: string | null;
  onOpenChange: (open: boolean) => void;
}) {
  const { data, isLoading } = useRiderSales(
    riderId ? { rider_id: riderId, status: "done", per_page: 100 } : undefined,
  );
  const items = data?.items ?? [];
  const [viewing, setViewing] = useState<RiderSale | null>(null);

  return (
    <Dialog open={riderId !== null} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Transaksi Belum Dibayar</DialogTitle>
          {riderName && (
            <DialogDescription>
              Daftar penjualan status "done" milik {riderName} yang belum masuk
              payroll.
            </DialogDescription>
          )}
        </DialogHeader>

        {isLoading ? (
          <p className="py-4 text-center text-sm text-muted-foreground">
            Memuat...
          </p>
        ) : items.length === 0 ? (
          <p className="py-4 text-center text-sm text-muted-foreground">
            Tidak ada transaksi.
          </p>
        ) : (
          <div className="overflow-x-auto rounded-md border">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Tanggal</TableHead>
                  <TableHead>ID Transaksi</TableHead>
                  <TableHead className="text-right">Omzet</TableHead>
                  <TableHead className="text-right">Bonus</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {items.map((s) => (
                  <TableRow key={s.id}>
                    <TableCell>{s.date}</TableCell>
                    <TableCell className="p-0">
                      <Button
                        type="button"
                        variant="link"
                        size="sm"
                        className="h-auto p-2 text-xs font-mono"
                        onClick={() => setViewing(s)}
                      >
                        {s.transactionCode ?? "-"}
                      </Button>
                    </TableCell>
                    <TableCell className="text-right">
                      {formatCurrency(s.totalRevenue)}
                    </TableCell>
                    <TableCell className="text-right">
                      {formatCurrency(s.totalBonus)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </DialogContent>

      <RiderSaleDetailDialog
        sale={viewing}
        onOpenChange={(open) => !open && setViewing(null)}
      />
    </Dialog>
  );
}
